/**
 * @Copyright 2014-2018 DataVoke, Inc. All rights reserved.
 */

import EventEmitter from "../support/eventemitter";

/**
 * The API object to represent UI Controls.
 * @class
 * @classdesc API Control Object
 */
export class BaseEntity extends EventEmitter {
    /**
     * Wrap the specified control object as a new API Control object.
     * @param {object} rawEntity - The entity object this API Control object wraps.
     */
    constructor(rawEntity) {
        super();

        /**
         * Internal reference to the control object.
         * @type {Object}
         */
        this.raw = rawEntity;

        /**
         * Object that should be used for custom logic to prevent breaking the core API
         * @type {Object}
         */
        this.runtime = {};
    }
}

/**
 * Class that handles any API methods related to the current user
 */
export class EntityApi {

    /**
     * Gets a Column object from the cache using it's PropertyID
     * @param {Object|Number} columnID - The columnID (PropertyID) or linker object of the column to find.
     * @returns {Object|null} The property if it was found
     */
    getColumnByID (columnID) {
        if (app.dv.cache.properties != null && app.dv.cache.properties.allProperties != null) {
            let col = app.dv.cache.properties.allProperties.getVal(columnID);
            return (col != null) ? new BaseEntity(col) : null;
        }
    }

    /**
     * Returns the title of the specified column.
     * @param {Object|Number} propertyID - The ID or linker object of the column to find.
     * @param {String} [titleIfNull] - The string to use if the column is not found.
     * @returns {String} The title of the specified column.
     */
    getColumnTitleByID (propertyID, titleIfNull) {
        if (propertyID == null || propertyID == 0) {
            // No property ID was specified return the fallback value..PW
            return titleIfNull;
        }

        if (app.dv.cache.properties != null && app.dv.cache.properties.allProperties != null) {
            const prop = app.dv.cache.properties.allProperties.getVal(propertyID);
            if (prop == null){
                // Property was not found in the cache, return fallback value..PW
                return titleIfNull;
            }

            return prop.Definition.Name;    // Return the title of the property..PW
        }

        // The cache doesn't exist, return the fallback value..PW
        return titleIfNull;
    }
}
